import { render, staticRenderFns } from "./IconWriteDefaultLayout.vue?vue&type=template&id=46d16737&scoped=true&"
import script from "./IconWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./IconWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d16737",
  null
  
)

export default component.exports